export const MIXPANEL_ERROR_TYPE = "error";
export const MIXPANEL_INFO_TYPE = "info";

export const MIXPANEL_MAGIC_LINK_EVENT = "magic_link_login_button_click";
export const MIXPANEL_WITH_PASSWORD_EVENT = "with_password_login_button_click";
export const MIXPANEL_FORGOT_PASSWORD_EVENT = "forgot_password_button_click";
export const MIXPANEL_RESET_PASSWORD_EVENT = "reset_password_button_click";
export const MIXPANEL_PASSWORD_RESET_SUCCESS_EVENT = "password_reset_success";
export const MIXPANEL_MAIN_REDIRECT_EVENT = "main_redirect";
export const MIXPANEL_VALIDATE_PAGE_EVENT = "validate_page";

export const MIXPANEL_MAGIC_LINK_PAGE_NAME = "Magic Link Login Page";
export const MIXPANEL_WITH_PASSWORD_PAGE_NAME = "Login With Password Page";
export const MIXPANEL_FORGOT_PASSWORD_PAGE_NAME = "Forgot Password Page";
export const MIXPANEL_RESET_PASSWORD_PAGE_NAME = "Reset Password Page";
export const MIXPANEL_VALIDATE_PAGE_NAME = "Validate Page, Access Login Page";

export const PASSWORD = "password";
export const MAGIC = "magic";
